import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AwsService, CommonService, TranslateService } from '__services';
import * as moment from 'moment';
import { PDFDocumentProxy, PDFProgressData } from 'ng2-pdf-viewer';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
})
export class PdfViewerComponent implements OnInit {
  @Input() set src(value) {
    if (value) {
      if (typeof value === 'string') {
        this.urlPDF = value;
      } else if (typeof value === 'object') {
        this.verifyPDF(value);
      }
    }
  };
  @Input() canDownload: boolean = false;
  @Input() canPrint: boolean = false;
  @Input() fileName: string;
  @Input() errorHash: string;
  @Output() pdfLoaded: EventEmitter<any> = new EventEmitter<any>();
  loaded: any;
  hasError: boolean;
  errorHashPDF: string;
  progress = '0%';
  pdf: PDFDocumentProxy;
  urlPDF: string = '';

  constructor(
    private commonService: CommonService,
    private translationService: TranslateService,
    private awsService: AwsService
  ) {}

  ngOnInit(): void {}

  onProgress(progressData: PDFProgressData): void {
    this.loaded = progressData.loaded === progressData.total;
    this.progress = `${(
      (progressData.loaded / progressData.total) *
      100
    ).toFixed()}%`;
  }

  verifyPDF(data) {
    const {s3_key, hash} = data;
    this.commonService.verifyDocumentReport({s3_key, hash}).subscribe(
      next => {
        if(next === true) {
          // this.commonService.processDocumentFromUrl(s3_key).subscribe(
          //   next => {
          //     this.urlPDF = next;
          //   }
          // )
          this.awsService.getUrlFile(s3_key).then((url) => {
            this.urlPDF = url;
          })
        } else {
          this.errorHashPDF = this.translationService.translate('File not available, please contact your Administrator.')
        }
      },
      error => {
        console.log(error);
      }
    )
  }

  onError(): void {
    this.loaded = true;
    this.hasError = true;
  }

  onLoaded(pdf: PDFDocumentProxy) {
    this.pdf = pdf;
  }

  download() {
    this.pdf.getData().then((u8) => {
      let blob = new Blob([u8.buffer], {
        type: 'application/pdf',
      });
      const nav: any = window.navigator;
      const date = moment().format("YYYYMMDD");
      this.fileName = `${date}_${this.fileName}`;
      if (nav && nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(blob, this.fileName);
      } else {
        // Chrome, Safari, Firefox, Opera
        let url = URL.createObjectURL(blob);
        this.openLink(url);
        // Remove the link when done
        setTimeout(function () {
          window.URL.revokeObjectURL(url);
        }, 3000);
      }
    });
  }

  private openLink(url: string) {
    let a = document.createElement('a');
    // Firefox requires the link to be in the body
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = url;
    a.download = this.fileName;
    a.click();
    // Remove the link when done
    document.body.removeChild(a);
  }

  print() {
    this.pdf.getData().then((u8) => {
      let blob = new Blob([u8.buffer], {
        type: 'application/pdf',
      });

      const blobUrl = window.URL.createObjectURL(blob);
      const previousIframe = document.getElementById('print_pdf');
      if (previousIframe) {
        previousIframe.remove();
      }

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = blobUrl;
      iframe.id = 'print_pdf';
      iframe.name = 'print_pdf';

      document.body.appendChild(iframe);
      iframe.contentWindow.print();
    });
  }
}
